<template>
  <div id="IndexSIPSIC_div">

    <menusuperior titulo="SIPSIC" subtitulo="Sistema de psicología"></menusuperior>
    <menuizquierda></menuizquierda>

    <div class="content-area">
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath"></router-view>
      </transition>
      <div id="bienvenida" class="d-flex justify-content-center align-items-center" v-if="$route.name == 'SIPSIC'">
        <div id="secciondebienvenida" class="d-flex flex-wrap align-items-center justify-content-center">
          <figure class="text-center" style="margin-top: 10em;">
            <img src="../../../assets/paginaoficial/Logotipo_Positivo_Vertical.png" alt="Logo de Poder Judicial del Estado de Aguascalientes" />
          </figure>          
        </div>
      </div>
    </div>
 
  </div>
</template>
<script>
  import menusuperior from '@/components/Comunes/MenuSuperior.vue'
  import menuizquierda from '@/components/Comunes/MenuIzquierdaDeLosSistemas.vue'
  import comun from '@/../static/js/comun'

  export default {
    name: 'Plantilla',
    components: {
      menusuperior: menusuperior,
      menuizquierda: menuizquierda
    }
  }
</script>
<style scoped>
  #secciondebienvenida {
    width: 40vw;
    height: 600px;
    align-content: center;
  }

  h2 {
    margin-top: 3vh;
    text-align: center;
  }

  h4 {
    margin-top: 1vh;
  }

  @media (max-width: 991px) {
    h2 {
      font-size: .9rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SIPSIC/Comun/Plantilla.vue